module.exports = __webpack_public_path__ + "img/small-arrow.5833fcb4.svg";